import { useAuth } from "@clerk/clerk-react";
import {
  Box,
  Button,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect, useState } from "react";

import { NEW_SUBSCRIBER_PROMO_PERCENTAGE } from "constants/influencer";
import { fetcherAuth } from "utils/api";

const HomeBanner = () => {
  const { getToken } = useAuth();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { subscription, setSubscription, setUpgradeDialogSource } =
    useContext(SubscriptionContext);
  const hasPromoDate = subscription?.newSubscriberPromoDate;

  const countDownDate = new Date(
    subscription?.newSubscriberPromoDate || 0,
  ).getTime();
  const [display, setDisplay] = useState<string | null>(null);

  const timer = setInterval(() => {
    const now = Date.now();
    const distance = countDownDate - now;

    // Time calculations
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    let text = "";
    if (days > 0) {
      text += `${days}d `;
    }
    if (hours > 0) {
      text += `${hours}h `;
    }
    if (minutes > 0) {
      text += `${minutes}m `;
    }
    text += `${seconds}s`;
    setDisplay(text);

    // When countdown is over
    if (distance < 0) {
      clearInterval(timer);
      setDisplay("");
    }
  }, 1000);

  const fetchUser = async () => {
    const res = await fetcherAuth(getToken, `/api/organization/auth/user`);
    setSubscription(res.subscription);
  };

  const hasPromo = Boolean(subscription?.newSubscriberPromoDate);
  useEffect(() => {
    if (!hasPromo) {
      fetchUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPromo]);

  if (!hasPromoDate || subscription?.isSubscribed) {
    return <></>;
  }

  return hasPromoDate && display ? (
    <Box
      sx={{
        backgroundColor: "#1d70ff",
        py: 0.5,
        px: { xs: 1, md: 2 },

        display: { xs: "auto", md: "flex" },
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box sx={{ py: 1 }}>
        <Typography
          sx={{ fontSize: { xs: 10, md: 14, color: "white" } }}
          textAlign="center"
        >
          Your exclusive {NEW_SUBSCRIBER_PROMO_PERCENTAGE}% discount{" "}
          {isMobileScreen ? "" : "on all plans"} expires in{" "}
          <strong>{display}</strong> ⏳
          {isMobileScreen && (
            <Link
              onClick={() => setUpgradeDialogSource("Countdown Banner")}
              sx={{
                borderRadius: 1,
                ml: 1,
                backgroundColor: "white",
                color: "info.main",
                p: 0.5,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              Upgrade{" "}
              <Box
                component="i"
                className="fa-regular fa-arrow-up-right-from-square"
              />
            </Link>
          )}
        </Typography>
      </Box>

      {!isMobileScreen && (
        <Button
          size="small"
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: "white",
            color: "info.main",
            "&:hover": { backgroundColor: grey[100] },
            my: { xs: 1, md: 0 },
          }}
          onClick={() => setUpgradeDialogSource("Countdown Banner")}
        >
          Upgrade Now{" "}
        </Button>
      )}
    </Box>
  ) : (
    <></>
  );
};

export default HomeBanner;
